import { getFilterMetadata } from '../../../../components/StatelessComponent/FilterChainUtils';
import { readableRadioDurationOperations } from '../../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericRadioDurationFilter/GenericRadioDurationDropdown';
import type {
  RadioDurationFilterValue,
  RadioDurationFilterValueType,
} from '../../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericRadioDurationFilter/GenericRadioDurationType';
import type { FilterKindEnum } from '../../../../domains/global-filters/model/FilterChain';
import type { LabelProps } from '../../LabelFormatterType';

export const getValueLabel = (value: RadioDurationFilterValueType): string => {
  if (!value) {
    return '';
  }
  if ('value' in value) {
    return `${readableRadioDurationOperations[value.operation]} "${value.value.amount} ${
      value.value.unit
    }${value.value.amount > 1 ? 's' : ''}"`;
  }
  if ('from' in value && 'to' in value) {
    return `${readableRadioDurationOperations[value.operation]} "${value.from.amount} ${
      value.from.unit
    }${value.from.amount > 1 ? 's' : ''}" and "${value.to.amount} ${value.to.unit}${
      value.to.amount > 1 ? 's' : ''
    }"`;
  }
  return readableRadioDurationOperations[value.operation];
};

export function getLabels(
  currentValue: RadioDurationFilterValue | undefined,
  filterKind: FilterKindEnum,
): LabelProps {
  const metadata = getFilterMetadata(filterKind);
  return {
    label1: metadata.filterName,
    label2: getValueLabel(currentValue),
  };
}
